import { MinMaxInput } from '@/components/Shared/MinMaxInput'
import { RadioButtons } from '@/components/Shared/RadioButtons'
import { Box } from '@mui/material'
import React from 'react'

interface ConfigSettingProps {
  minMaxValues: { min: string; max: string }
  configSettingType: string
  configSettingOptions: string[]
  selectedConfigSetting: { [key: string]: string }
  setSelectedConfigSetting: (selectedConfigSetting: any) => void
  onValueChange: (values: { min: string; max: string }) => void
}

export const ConfigSettingUI: React.FC<ConfigSettingProps> = ({
  minMaxValues,
  selectedConfigSetting,
  configSettingOptions,
  configSettingType,
  onValueChange,
  setSelectedConfigSetting,
}) => {
  const onSelectionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedConfigSetting((prev: any) => ({
      ...prev,
      [configSettingType]: e.target.value, // or e.target.value depending on your input type
    }))
  }
  return (
    <>
      <MinMaxInput
        minValue={minMaxValues.min}
        maxValue={minMaxValues.max}
        onValueChange={onValueChange}
        minLabel='Minimum'
        maxLabel='Maximum'
      />
      <Box marginTop={2}>
        <RadioButtons
          layout='vertical'
          value={selectedConfigSetting[configSettingType]}
          onChange={onSelectionChange}
          options={configSettingOptions}
        />
      </Box>
    </>
  )
}
